module.exports = {
  secondsToDays(seconds) {
    const days = Math.floor(seconds / (3600 * 24));
    return days;
  },

  /*
    if seconds > 24 hours reurn only the hours result
    seconds = 457200 (5 days 7 hours) return -> 7 hours
  */
  secondsToHours(seconds) {
    const hours = Math.floor((seconds % (3600 * 24)) / 3600);
    return hours;
  },

  daysToSeconds(days) {
    const seconds = days * (24 * 3600);
    return seconds;
  },

  hoursToSeconds(hours) {
    const seconds = hours * 3600;
    return seconds;
  },
};
